import { defineStore } from "pinia"
import { computed, ref, type Ref } from "vue"
import { ProductionStatement } from "@/models/production-statement.model"

export const useProductionStatementStore = defineStore("productionStatementsStore", () => {
  const productionStatements: Ref<ProductionStatement[]> = ref([])

  const outstandingProductionStatements = computed(() =>
    productionStatements.value.filter((statement) => statement.isOutstanding())
  )

  return {
    productionStatements,
    outstandingProductionStatements
  }
})
